import { createSelector } from '@reduxjs/toolkit';
import { ProjectParameters } from 'ducks/types/store-types';
import { RootState } from 'store';

const batchDefinitionParametersSlice = (state: RootState) => state.batch_definition_parameters;

export const selectBatchDefinitionParameters = createSelector(
  [batchDefinitionParametersSlice],
  (state): ProjectParameters => state,
);
